import React from 'react'
import Styles from './BrandPlanCurrentVolumeV2.module.scss'
import { Text } from 'blaze-ui/Text/Text'

type Props = {
  amount: number
  totalAmount: number
}

export const ProgressCircle = ({ amount, totalAmount }: Props): React.ReactElement => {
  const percentage = (amount / totalAmount) * 100
  const radius = 62
  const strokeWidth = 4
  const normalizedRadius = radius - strokeWidth * 2
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDasharray = `${circumference} ${circumference}`
  const strokeDashoffset = circumference - (percentage / 100) * circumference

  return (
    <div className={Styles.progressCircleContainer}>
      <div className={Styles.progressCircle}>
        <svg className={Styles.progressSvg} width={127} height={127}>
          {/* Background circle */}
          <circle
            className={Styles.progressBackground}
            fill="transparent"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Progress circle */}
          <circle
            className={Styles.progressForeground}
            fill="transparent"
            strokeDasharray={strokeDasharray}
            style={{
              strokeDashoffset,
              transition: 'stroke-dashoffset 0.3s ease-in-out',
            }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            transform={`rotate(-90 ${radius} ${radius})`}
          />
        </svg>
        <div className={Styles.progressContent}>
          <Text>
            <div className={Styles.progressAmount}>{`${amount}/${totalAmount}`}</div>
          </Text>
          <Text>
            <div className={Styles.connectedText}>Connected</div>
          </Text>
        </div>
      </div>
    </div>
  )
}
